import apiClient from '../lib/apiClient';
import Parse from "parse";
const URL = process.env.REACT_APP_API_URL
const PARSE_APP_ID = process.env.REACT_APP_PARSE_APP_ID
const PARSE_JAVASCRIPT_KEY = process.env.REACT_APP_PARSE_JS_KEY
const PARSE_SERVER_URL = process.env.REACT_APP_PARSE_URL


const init = () => {
    Parse.initialize(PARSE_APP_ID, PARSE_JAVASCRIPT_KEY);
    Parse.serverURL = PARSE_SERVER_URL
};

export const login = async (info) => {
    init()
    const { username, password } = info
    try {
        if (!username || !password) {
            return { status: 'error', message: 'Please fill in the username and password' };
        }
        const check = await checkRewardRegistration(username)
        if (check.status === 'error') {
            return { status: 'error', message: check.message };
        }
        const user = await Parse.User.logIn(username, password);
        if (user) {
            const isUse2FA = user.get('isUse2FA')
            return { status: 'success', message: 'Log in success', user, token: user.getSessionToken(), isUse2FA };
        }
        return { status: 'error', message: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่าน' };
    } catch (error) {
        return { status: 'error', message: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่าน' };
    }
}

export const checkRewardRegistration = async (phone) => {
    try {
        const res = await apiClient.post(`${URL}/user/reward/check`, { phone })
        return res.data;
    } catch (error) {
        return { status: 'error', message: error.message }
    }
}

export const getCurrentUser = async () => {
    init()
    const token = window.localStorage.getItem('token')
    try {
        if (token) {
            const user = await Parse.User.become(token)
            return user
        } else {
            return null
        }
    } catch (error) {
        console.log('getCurrentUser error :>> ', error.message);
        return null
    }

}

export const logout = async () => {
    init()
    await Parse.User.logOut();
    window.localStorage.removeItem('token');
}

export const getRewardItem = async () => {
    try {
        const res = await apiClient(`${URL}/reward/item`)
        const { data } = res.data
        return { status: 'success', data };
    } catch (error) {
        return { status: 'error', message: error.message }
    }

}

export const fetchGet = () => (
    apiClient.get(process.env.REACT_APP_API_URL + "/")
)

export const fetchPost = values => (
    apiClient.post(process.env.REACT_APP_API_URL + "/login/" + JSON.stringify(values), {
        headers: {
            "content-type": "application/json"
        }
    })
)

export const fetchPush = (id, values) => {
    return dispatch => {
        // axios.put(process.env.REACT_APP_API_URL + "/lists/" + id, values).then(
        //     res => {
        //         dispatch({ type: UPDATE_LIST });
        //     }
        // )
    }
}

export const fetchDelete = values => {
    return dispatch => {
        // axios.delete(process.env.REACT_APP_API_URL + "/lists/" + values).then(res => {
        //     apiClient.get(process.env.REACT_APP_API_URL + "/").then(
        //         res => {
        //             dispatch({ type: LOAD_LIST, payload: res.data });
        //         }
        //     )
        // })
    }
}
